function icon_arrow() {
    return (
        <svg width="25" height="36" viewBox="0 0 25 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.8463 12.366C18.7534 8.31786 16.4587 6.04823 12.3659 2.00006M12.3659 2.00006L1.99992 12.4804M12.3659 2.00006L12.366 33.4428" stroke="#6DDE72" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default icon_arrow